import { ORG_STATUSES } from '@carcheck/shared';
import { z } from 'zod';

/**
 * URL filter schema for `/companies` (AUT-403). Mirrors the API's
 * `ListOrgsQuerySchema`: `status` (all | active | suspended | terminated)
 * and `q` (name, legal name or УНП prefix — the server decides). The
 * mockup's «Город» and «Скрыть демо» chips have no server filter yet, so
 * they are not here. Junk degrades to the default.
 */
export const STATUS_OPTIONS = ['all', ...ORG_STATUSES] as const;

export const companyFiltersSchema = z.object({
  status: z.enum(STATUS_OPTIONS).catch('all').default('all'),
  q: z.string().optional().catch(undefined),
});

export type CompanyFilters = z.infer<typeof companyFiltersSchema>;

export const hasActiveFilters = (f: CompanyFilters): boolean => f.status !== 'all' || Boolean(f.q);

/** A stable string of the filters: a change resets the cursor stack. */
export const filterKeyOf = (f: CompanyFilters): string => [f.status, f.q ?? ''].join('|');
